var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "query-page" }, [
    _c(
      "div",
      { staticClass: "page-inner" },
      [
        _c(
          "el-form",
          {
            staticClass: "form step-content",
            attrs: { model: _vm.query, "label-width": "130px" },
          },
          [
            _c("img", {
              staticClass: "banner",
              attrs: {
                src: require("@/assets/img/complex_query.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "title" }, [_vm._v("複合查詢")]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", maxlength: "20" },
                        model: {
                          value: _vm.query.NameKeyword,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "NameKeyword", $$v)
                          },
                          expression: "query.NameKeyword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "性別" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.query.Sex,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "Sex", $$v)
                            },
                            expression: "query.Sex",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "男", value: 0 } }),
                          _c("el-option", { attrs: { label: "女", value: 1 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "國籍" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            "value-key": "Guid",
                            multiple: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.query.Nationalities,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "Nationalities", $$v)
                            },
                            expression: "query.Nationalities",
                          },
                        },
                        _vm._l(_vm.countryOptions, function (country) {
                          return _c("el-option", {
                            key: country.Guid,
                            attrs: { label: country.Name, value: country.Name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "後續聯絡" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { clearable: "", multiple: "" },
                          model: {
                            value: _vm.query.ResumeContactRemarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ResumeContactRemarks", $$v)
                            },
                            expression: "query.ResumeContactRemarks",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "可再約", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "永不聯絡", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "通訊地址縣市" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            "value-key": "Guid",
                          },
                          model: {
                            value: _vm.query.ContactCounties,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ContactCounties", $$v)
                            },
                            expression: "query.ContactCounties",
                          },
                        },
                        _vm._l(_vm.cityOptions, function (city) {
                          return _c("el-option", {
                            key: city.Guid,
                            attrs: { label: city.Name, value: city.Name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "通訊地址區域" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { multiple: "", filterable: "" },
                          model: {
                            value: _vm.query.ContactDistricts,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ContactDistricts", $$v)
                            },
                            expression: "query.ContactDistricts",
                          },
                        },
                        _vm._l(_vm.districtOptions, function (district) {
                          return _c("el-option", {
                            key: district.Name,
                            attrs: {
                              label: district.Name,
                              value: district.Name,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "經驗分類" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            "value-key": "Guid",
                            placeholder: "請選擇",
                          },
                          model: {
                            value: _vm.query.ResumeTags,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ResumeTags", $$v)
                            },
                            expression: "query.ResumeTags",
                          },
                        },
                        _vm._l(_vm.resumeTagOptions, function (resumeTag) {
                          return _c("el-option", {
                            key: resumeTag.Guid,
                            attrs: {
                              label: resumeTag.Name,
                              value: resumeTag.Name,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "其他分類" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            multiple: "",
                            filterable: "",
                            "value-key": "Guid",
                            placeholder: "請選擇",
                          },
                          model: {
                            value: _vm.query.ResumeFreeTags,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ResumeFreeTags", $$v)
                            },
                            expression: "query.ResumeFreeTags",
                          },
                        },
                        _vm._l(_vm.freeTagOptions, function (freeTag) {
                          return _c("el-option", {
                            key: freeTag.Guid,
                            attrs: { label: freeTag.Name, value: freeTag.Name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "過往應徵職缺" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "請選擇",
                          },
                          model: {
                            value: _vm.query.ManpowerDemandNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "ManpowerDemandNo", $$v)
                            },
                            expression: "query.ManpowerDemandNo",
                          },
                        },
                        _vm._l(_vm.positionOptions, function (position) {
                          return _c("el-option", {
                            key: position.Value,
                            attrs: {
                              label: position.Text,
                              value: position.Value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "category",
                class: { open: _vm.educationCollapse === true },
              },
              [
                _c("div", { staticClass: "sp" }, [
                  _c("span", [_vm._v("學歷")]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "學校" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.Schools,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "Schools", $$v)
                                },
                                expression: "query.Schools",
                              },
                            },
                            _vm._l(_vm.schoolOptions, function (school) {
                              return _c("el-option", {
                                key: school.Guid,
                                attrs: {
                                  label: school.Name,
                                  value: school.Name,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "科系類別" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.Majors,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "Majors", $$v)
                                },
                                expression: "query.Majors",
                              },
                            },
                            _vm._l(_vm.majorOptions, function (major) {
                              return _c("el-option", {
                                key: major.Guid,
                                attrs: { label: major.Name, value: major.Name },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "科系" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.MajorNameKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "MajorNameKeyword", $$v)
                              },
                              expression: "query.MajorNameKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "toggle-btn-wrap" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.educationCollapse = !_vm.educationCollapse
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.workExperienceCollapse
                          ? "收合學歷選項"
                          : "展開學歷選項"
                      ) +
                      " "
                  ),
                  _c("eva-icon", {
                    attrs: {
                      name: _vm.educationCollapse
                        ? "chevron-up-outline"
                        : "chevron-right-outline",
                      fill: "#222",
                      width: "15",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "category",
                class: { open: _vm.workExperienceCollapse === true },
              },
              [
                _c("div", { staticClass: "sp" }, [
                  _c("span", [_vm._v("工作經歷")]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "總年資起迄" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "165px" },
                            attrs: {
                              size: "medium",
                              min: 0,
                              max: 99.9,
                              precision: 1,
                              step: 0.1,
                            },
                            model: {
                              value: _vm.query.TotalSeniorityMin,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "TotalSeniorityMin", $$v)
                              },
                              expression: "query.TotalSeniorityMin",
                            },
                          }),
                          _vm._v(" 至 "),
                          _c("el-input-number", {
                            staticStyle: { width: "165px" },
                            attrs: {
                              size: "medium",
                              min: 0,
                              max: 99.9,
                              precision: 1,
                              step: 0.1,
                            },
                            model: {
                              value: _vm.query.TotalSeniorityMax,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "TotalSeniorityMax", $$v)
                              },
                              expression: "query.TotalSeniorityMax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "希望年薪起迄" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "165px" },
                            attrs: { size: "medium", min: 0, max: 99999999 },
                            model: {
                              value: _vm.query.ExpectedYearlySalaryMin,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.query,
                                  "ExpectedYearlySalaryMin",
                                  $$v
                                )
                              },
                              expression: "query.ExpectedYearlySalaryMin",
                            },
                          }),
                          _vm._v(" 至 "),
                          _c("el-input-number", {
                            staticStyle: { width: "165px" },
                            attrs: { size: "medium", min: 0, max: 99999999 },
                            model: {
                              value: _vm.query.ExpectedYearlySalaryMax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.query,
                                  "ExpectedYearlySalaryMax",
                                  $$v
                                )
                              },
                              expression: "query.ExpectedYearlySalaryMax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "曾任職公司" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.CompanyKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "CompanyKeyword", $$v)
                              },
                              expression: "query.CompanyKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "曾任職產業" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.query.IndustryCategories,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "IndustryCategories", $$v)
                                },
                                expression: "query.IndustryCategories",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "電子產業", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "封測產業", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "傳統產業", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "其他產業", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "曾任職職務" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.PositionKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "PositionKeyword", $$v)
                              },
                              expression: "query.PositionKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "toggle-btn-wrap" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.workExperienceCollapse = !_vm.workExperienceCollapse
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.workExperienceCollapse
                          ? "收合工作經歷選項"
                          : "展開工作經歷選項"
                      ) +
                      " "
                  ),
                  _c("eva-icon", {
                    attrs: {
                      name: _vm.workExperienceCollapse
                        ? "chevron-up-outline"
                        : "chevron-right-outline",
                      fill: "#222",
                      width: "15",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "category",
                class: { open: _vm.skillCollapse === true },
              },
              [
                _c("div", { staticClass: "sp" }, [
                  _c("span", [_vm._v("專業技能")]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "專業技能" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.SkillKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "SkillKeyword", $$v)
                              },
                              expression: "query.SkillKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "培訓紀錄" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.TrainingRecordKeyword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.query,
                                  "TrainingRecordKeyword",
                                  $$v
                                )
                              },
                              expression: "query.TrainingRecordKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "證照檢定" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.CertificateKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "CertificateKeyword", $$v)
                              },
                              expression: "query.CertificateKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "挫折忍耐度" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.query.FrustrationTolerances,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.query,
                                    "FrustrationTolerances",
                                    $$v
                                  )
                                },
                                expression: "query.FrustrationTolerances",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "高", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "中", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "低", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言種類" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.Languages,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "Languages", $$v)
                                },
                                expression: "query.Languages",
                              },
                            },
                            _vm._l(_vm.languageOptions, function (language) {
                              return _c("el-option", {
                                key: language.Guid,
                                attrs: {
                                  label: language.Name,
                                  value: language.Name,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言檢定" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", maxlength: "50" },
                            model: {
                              value: _vm.query.LanguageTestKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "LanguageTestKeyword", $$v)
                              },
                              expression: "query.LanguageTestKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言程度(聽)" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.LanguageListenGuids,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.query,
                                    "LanguageListenGuids",
                                    $$v
                                  )
                                },
                                expression: "query.LanguageListenGuids",
                              },
                            },
                            _vm._l(_vm.degreeOptions, function (degree) {
                              return _c("el-option", {
                                key: degree.Guid,
                                attrs: {
                                  label: degree.Name,
                                  value: degree.Guid,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言程度(說)" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.LanguageSpeakGuids,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "LanguageSpeakGuids", $$v)
                                },
                                expression: "query.LanguageSpeakGuids",
                              },
                            },
                            _vm._l(_vm.degreeOptions, function (degree) {
                              return _c("el-option", {
                                key: degree.Guid,
                                attrs: {
                                  label: degree.Name,
                                  value: degree.Guid,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言程度(讀)" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.LanguageReadGuids,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "LanguageReadGuids", $$v)
                                },
                                expression: "query.LanguageReadGuids",
                              },
                            },
                            _vm._l(_vm.degreeOptions, function (degree) {
                              return _c("el-option", {
                                key: degree.Guid,
                                attrs: {
                                  label: degree.Name,
                                  value: degree.Guid,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "語言程度(寫)" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                placeholder: "請選擇",
                              },
                              model: {
                                value: _vm.query.LanguageWriteGuids,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "LanguageWriteGuids", $$v)
                                },
                                expression: "query.LanguageWriteGuids",
                              },
                            },
                            _vm._l(_vm.degreeOptions, function (degree) {
                              return _c("el-option", {
                                key: degree.Guid,
                                attrs: {
                                  label: degree.Name,
                                  value: degree.Guid,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "toggle-btn-wrap" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.skillCollapse = !_vm.skillCollapse
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.skillCollapse
                          ? "收合專業技能選項"
                          : "展開專業技能選項"
                      ) +
                      " "
                  ),
                  _c("eva-icon", {
                    attrs: {
                      name: _vm.skillCollapse
                        ? "chevron-up-outline"
                        : "chevron-right-outline",
                      fill: "#222",
                      width: "15",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "category",
                class: { open: _vm.workCooperationCollapse === true },
              },
              [
                _c("div", { staticClass: "sp" }, [
                  _c("span", [_vm._v("工作相關")]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("el-form-item", { attrs: { label: "配合日夜輪班" } }, [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-radio" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.CanShiftWork,
                                    expression: "query.CanShiftWork",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.query.CanShiftWork, true),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "CanShiftWork",
                                      true
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("是")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.CanShiftWork,
                                    expression: "query.CanShiftWork",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(
                                    _vm.query.CanShiftWork,
                                    false
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "CanShiftWork",
                                      false
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("否")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.CanShiftWork,
                                    expression: "query.CanShiftWork",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(_vm.query.CanShiftWork, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "CanShiftWork",
                                      null
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("不拘")]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "配合「出差/派駐」" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { clearable: "", multiple: "" },
                              model: {
                                value: _vm.query.CanOfficeTripOrStations,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.query,
                                    "CanOfficeTripOrStations",
                                    $$v
                                  )
                                },
                                expression: "query.CanOfficeTripOrStations",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "否 No", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "可接受1-3個月", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "可接受半年", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "可接受1年", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "可接受2年以上", value: 4 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("el-form-item", { attrs: { label: "影響工作配合" } }, [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-radio" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasLackOfWorkCooperation,
                                    expression:
                                      "query.HasLackOfWorkCooperation",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(
                                    _vm.query.HasLackOfWorkCooperation,
                                    true
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "HasLackOfWorkCooperation",
                                      true
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("是")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasLackOfWorkCooperation,
                                    expression:
                                      "query.HasLackOfWorkCooperation",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(
                                    _vm.query.HasLackOfWorkCooperation,
                                    false
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "HasLackOfWorkCooperation",
                                      false
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("否")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasLackOfWorkCooperation,
                                    expression:
                                      "query.HasLackOfWorkCooperation",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(
                                    _vm.query.HasLackOfWorkCooperation,
                                    null
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.query,
                                      "HasLackOfWorkCooperation",
                                      null
                                    )
                                  },
                                },
                              }),
                              _c("span", [_vm._v("不拘")]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("el-form-item", { attrs: { label: "有保密義務" } }, [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-radio" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNDA,
                                    expression: "query.HasNDA",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.query.HasNDA, true),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNDA", true)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("是")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNDA,
                                    expression: "query.HasNDA",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(_vm.query.HasNDA, false),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNDA", false)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("否")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNDA,
                                    expression: "query.HasNDA",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(_vm.query.HasNDA, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNDA", null)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("不拘")]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("el-form-item", { attrs: { label: "有禁止條款" } }, [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-radio" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNCC,
                                    expression: "query.HasNCC",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.query.HasNCC, true),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNCC", true)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("是")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNCC,
                                    expression: "query.HasNCC",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(_vm.query.HasNCC, false),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNCC", false)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("否")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasNCC,
                                    expression: "query.HasNCC",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(_vm.query.HasNCC, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasNCC", null)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("不拘")]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("el-form-item", { attrs: { label: "有智財" } }, [
                        _c("div", { staticClass: "field" }, [
                          _c("div", { staticClass: "field-radio" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasIP,
                                    expression: "query.HasIP",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: true,
                                  checked: _vm._q(_vm.query.HasIP, true),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasIP", true)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("是")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasIP,
                                    expression: "query.HasIP",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: false,
                                  checked: _vm._q(_vm.query.HasIP, false),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasIP", false)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("否")]),
                            ]),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.query.HasIP,
                                    expression: "query.HasIP",
                                  },
                                ],
                                attrs: { type: "radio" },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(_vm.query.HasIP, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.query, "HasIP", null)
                                  },
                                },
                              }),
                              _c("span", [_vm._v("不拘")]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "toggle-btn-wrap" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.workCooperationCollapse = !_vm.workCooperationCollapse
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.workCooperationCollapse
                          ? "收合工作相關選項"
                          : "展開工作相關選項"
                      ) +
                      " "
                  ),
                  _c("eva-icon", {
                    attrs: {
                      name: _vm.workCooperationCollapse
                        ? "chevron-up-outline"
                        : "chevron-right-outline",
                      fill: "#222",
                      width: "15",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "category",
                class: { open: _vm.resumeStatusCollapse === true },
              },
              [
                _c("div", { staticClass: "sp" }, [
                  _c("span", [_vm._v("履歷狀態相關")]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "聯繫狀態" } },
                        [
                          _c("el-cascader", {
                            staticClass: "w-100",
                            attrs: {
                              options: _vm.contactOptions,
                              clearable: "",
                              props: _vm.cascaderProps,
                              "show-all-levels": false,
                              placeholder: "請選擇",
                            },
                            model: {
                              value: _vm.query.ContactStatusGuids,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "ContactStatusGuids", $$v)
                              },
                              expression: "query.ContactStatusGuids",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "招募狀態" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { clearable: "", multiple: "" },
                              model: {
                                value: _vm.query.recruitStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "recruitStatus", $$v)
                                },
                                expression: "query.recruitStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "尚未邀約", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "待面談", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "已面談", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "面談未到", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "面談結果" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { clearable: "", multiple: "" },
                              model: {
                                value: _vm.query.interviewResult,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "interviewResult", $$v)
                                },
                                expression: "query.interviewResult",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "複試", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "錄取", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "考慮中", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "不錄取", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "任用結果" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: { clearable: "", multiple: "" },
                              model: {
                                value: _vm.query.appointResult,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "appointResult", $$v)
                                },
                                expression: "query.appointResult",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "簽核中", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Process Fail", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "Offer Fail", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "待報到", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "已報到", value: 4 },
                              }),
                              _c("el-option", {
                                attrs: { label: "人力凍結", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "單位 Reject", value: 6 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "toggle-btn-wrap" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      _vm.resumeStatusCollapse = !_vm.resumeStatusCollapse
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.resumeStatusCollapse
                          ? "收合履歷狀態選項"
                          : "展開履歷狀態選項"
                      ) +
                      " "
                  ),
                  _c("eva-icon", {
                    attrs: {
                      name: _vm.resumeStatusCollapse
                        ? "chevron-up-outline"
                        : "chevron-right-outline",
                      fill: "#222",
                      width: "15",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "send-wrap" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.search } },
                  [_vm._v("查詢")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.query = {}
                      },
                    },
                  },
                  [_vm._v("清除")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }